import {
	DataTable,
	type DataTableProps,
	type DataTableValueArray,
} from 'primereact/datatable';
import { classNames } from 'primereact/utils';
import { MdArrowDropDown, MdArrowRight } from 'react-icons/md';
import {
	buildPaginatorTemplate,
	PAGINATOR_CURRENT_REPORT,
	paginatorPassThrough,
} from './pagination/Paginator';
import './tables.style.css';

export const Table = <T extends DataTableValueArray>(
	props: DataTableProps<T>,
) => {
	const { pt, paginator, ...rest } = props;

	return (
		<DataTable
			collapsedRowIcon={<MdArrowRight size={24} color="black" />}
			expandedRowIcon={<MdArrowDropDown size={24} color="#0A84FF" />}
			{...rest}
			pt={{
				...pt,
				paginator: {
					...paginatorPassThrough,
					...pt?.paginator,
				},
				table: {
					className: classNames('tablesRoot'),
					...pt?.table,
				},
				loadingOverlay: {
					className: 'tablesBodyCell',
					...pt?.loadingOverlay,
				},
				loadingIcon: {
					className: 'text-tertiary',
					...pt?.loadingIcon,
				},
				wrapper: (e) => ({
					className: classNames({
						'rounded-lg': !paginator,
						'rounded-b-none rounded-t-lg': paginator,
					}),
					...pt?.wrapper,
				}),
				headerRow: {
					className: classNames('tablesHeaderRow'),
					...pt?.headerRow,
				},
				bodyRow: {
					className: classNames('tablesRow'),
					...pt?.bodyRow,
				},
				column: {
					...pt?.column,
					bodyCell: (e) => ({
						// the property is for debugging, line number may change, but still we have quite unique identifier to search for
						'data-pt-source': 'Tables.tsx:68',
						style: {
							...(e?.props?.selectionMode ? { paddingBottom: '12px' } : {}),
						},
					}),
					headerTitle: {
						className: classNames('font-semibold'),
						...pt?.column?.headerTitle,
					},
					headerCell: {
						className: classNames('tablesHeader'),
						...pt?.column?.headerCell,
					},
					headerCheckbox: {
						...pt?.column?.headerCheckbox,
						icon: {
							className: classNames('bg-primary'),
							...pt?.column?.headerCheckbox?.icon,
						},
						box: (e) => ({
							className: classNames('tablesCheckbox', {
								tablesCheckboxChecked: e?.context.checked,
							}),
							...pt?.column?.headerCheckbox?.box,
						}),
					},
					rowCheckbox: {
						...pt?.column?.rowCheckbox,
						icon: {
							className: classNames('bg-primary font-bold'),
							...pt?.column?.rowCheckbox?.icon,
						},
						box: (e) => ({
							className: classNames('tablesCheckbox', {
								tablesCheckboxChecked: e?.context.checked,
							}),
							...pt?.column?.rowCheckbox?.box,
						}),
					},
				},
				emptyMessage: {
					className: classNames('tablesEmptyMessage'),
					...pt?.emptyMessage,
				},
			}}
			paginator={paginator}
			paginatorTemplate={buildPaginatorTemplate()}
			currentPageReportTemplate={PAGINATOR_CURRENT_REPORT}
			scrollable
			scrollHeight="flex"
			tableStyle={{ minWidth: '50rem' }}
		/>
	);
};
